import { useState } from "react";
import { usePortalAuth } from "@/context/PortalAuthContext";
import { Save, Loader2 } from "lucide-react";
import portalApi from "@/lib/portalApi";
import { useT } from "@/i18n";

export default function PortalAccount() {
  const { user, checkAuth } = usePortalAuth();
  const t = useT();
  const p = t.portal;
  const [form, setForm] = useState({ phone: user?.phone || "", email: user?.email || "" });
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setSaving(true); setSuccess(false);
    try { await portalApi.put("/portal/account", form); await checkAuth(); setSuccess(true); setTimeout(() => setSuccess(false), 3000); } catch { /* */ }
    setSaving(false);
  };

  return (
    <div data-testid="portal-account">
      <h1 className="crm-heading mb-8">{p.accountTitle}</h1>
      <form onSubmit={handleSubmit} className="max-w-lg space-y-6">
        <div className="crm-card p-6 space-y-4">
          <h2 className="crm-subheading">{p.personalData}</h2>
          <div>
            <label className="crm-label">{p.name}</label>
            <input disabled value={user?.name || ""} className="crm-input opacity-60" />
            <p className="text-xs mt-1" style={{ color: "var(--crm-text-dim)" }}>{p.nameChangeNote}</p>
          </div>
          <div>
            <label className="crm-label">{p.email}</label>
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="crm-input" />
          </div>
          <div>
            <label className="crm-label">{p.phone}</label>
            <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="crm-input" placeholder="090-XXXX-XXXX" />
          </div>
        </div>
        {success && <div className="p-3 rounded-xl text-sm font-medium" style={{ background: "rgba(16,185,129,0.1)", color: "#10b981" }}>{p.saved}</div>}
        <button type="submit" disabled={saving} className="crm-btn-primary">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} {p.save}
        </button>
      </form>
    </div>
  );
}
